import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsEnvAssessmentAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const documentCategory = control.get('documentCategory')!.value;
	const coverProcessId = control.get('coverProcessId')!.value;
	const documentTypeArray = ['EGD022', 'EGD025', 'EGD031'];


	return !coverProcessId && !!documentType && documentCategory === 'EGD08'  && !documentTypeArray.includes(documentType) ?
		{ checkDocCategoryIsEnvAssessmentAndDocTypeAllowedFlag: true } : null;

};
